/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'

import { positionRegistryKey, positionsRegistry } from '@root/entities/position'

import type { PairAddress } from '../model'
import type { Network } from '@root/entities/network'

export const reatomPairPosition = ({
  network,
  pairAddress,
}: {
  network: Network.Network
  pairAddress: PairAddress
}) => {
  const positionAtom = atom((ctx) => {
    const registryKey = positionRegistryKey(pairAddress, network)
    const positions = ctx.spy(positionsRegistry.positionsAtom)
    return positions.get(registryKey)
  })

  return {
    position: positionAtom,
  }
}
